<template>
    <section class="section">
        <b-row>
            <b-col>
                <b-card title="Esporta dati">
                    <form role="form" ref="form" class="mt-5" novalidate @submit.prevent="handleSubmit" >
                        <div>
                            <label>Canali e parametri</label>
                            <v-select 
                                multiple
                                v-model="channels"
                                :reduce="item => item.value"
                                :options="channelsList"
                                label="label"
                                value="value"
                                :filter-by="channelsFilter"
                                :selectable="(option) => ! option.group" />
                        </div>
                        <label class="mt-3">Periodo</label>
                        <b-row class="d-flex width-490">
                            <b-col class="d-flex align-items-center">
                                <label class="mr-2">Dal</label>
                                <div class="form-control">
                                    <date-pick
                                        v-model="fromDate"
                                        :months="monthsNames"
                                        :weekdays="daysNames"
                                        :selectableYearRange="5"
                                        :format="'DD/MM/YYYY'" />
                                </div>
                            </b-col>
                            <b-col class="d-flex align-items-center">
                                <label class="mr-2">Al</label>
                                <div class="form-control">
                                    <date-pick
                                        v-model="toDate"
                                        :months="monthsNames"
                                        :weekdays="daysNames"
                                        :selectableYearRange="5"
                                        :format="'DD/MM/YYYY'" />
                                </div>
                            </b-col>
                        </b-row>
                        <label class="mt-5">Il tool esporta al massimo 1.000.000 di record</label>
                        <div class="mt-1">
                            <button type="submit" class="btn btn-success">Esporta CSV</button>
                        </div>
                    </form>
                </b-card>
            </b-col>
        </b-row>
    </section>
</template>

<script>
import vSelect from 'vue-select';
import DatePick from 'vue-date-pick';
import moment from 'moment';

export default {
    components: { 
        vSelect,
        DatePick
    },
    name: "ExportData",
    data() {
        return {
            channels: [],
            fromDate: null,
            toDate: null,
            channelsList: [],
        }
    },

    created() {
        this.loadChannels();
    },
    
    methods: {
        async handleSubmit() {
            if(! this.fromDate || ! this.toDate) {
                this.$refs.form.classList.add('was-validated');
                this.$notify({
                    type: "error",
                    text: "Inserire le date di inizio e fine campionamento",
                    title: 'Errore',
                });
                return;
            } else {
                await this.export();
            }
        },
        
        async export() {
            this.$store.commit("loading");
            try {
                let params = {
                    sources: this.channels, 
                    from: moment(this.fromDate).toISOString(), 
                    to: moment(this.toDate).toISOString()
                }
                this.$store.dispatch('data/export', params).then((response) => {
                    const type = response.headers['content-type'];
                    const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "export.csv";
                    link.click();
                    this.$store.commit("stopLoading");
                })
            } catch(e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
                return;
            }
        },

        loadChannels() {
            this.$store.state.user.sites.forEach(site => {
                if(site.channels) {
                    this.channelsList.push({ label: "Canali", value: null, group: true });
                    site.channels.forEach(item => {
                        this.channelsList.push({ label: item.name, value: item.code });
                    });
                } 
                if(site.parameters) {
                    this.channelsList.push({ label: "Parametri", value: null, group: true });
                    site.parameters.forEach(item => {
                        this.channelsList.push({ label: item.name, value: item.code });
                    });
                }
            });
        },

        channelsFilter(option, label, search) {
            if(search) {
                let temp = search.toLowerCase();
                let label = option.label || "";
                let value = option.value || "";

                return label.toLowerCase().indexOf(temp) > -1 ||
                    value.toLowerCase().indexOf(temp) > -1 || 
                    option.group
            }
        },
    },

    computed: {
        monthsNames() {
            return this.$store.state.utils.months;
        },
        daysNames() {
            return this.$store.state.utils.daysShort;
        },
    },
}
</script>

<style scoped>
    .width-490 {
        width: 490px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/ExportData/ExportData.vue